import { MetricLocalization, MetricPointPlatformType } from "@/types";

export const isOwerweightText = (record: boolean): string => {
    if (record) {
        return 'Pojazd przeciążony';
    }
    return 'Waga poprawna';
};

export const  isSensorMissed = (value: boolean): string => {
    if (value) {
        return 'Tak (waga szacunkowa)';
    }
    return 'Nie';
};

export const badgeVariant = (value: boolean): 'red' | 'green' => {
    if (value) {
        return 'red';
    }
    return 'green';
};

export const mapToFullPlatform = (metricPointPlatformUId: string, metricLocalization: MetricLocalization | null | undefined): string => {
    if(metricLocalization == null){
        return 'Brak danych'; 
    }
    const localizations = metricLocalization.metricPointPlatforms;
    const pointPlatrofm: MetricPointPlatformType | undefined = localizations.find((x: MetricPointPlatformType) => x.uId === metricPointPlatformUId);
    if (pointPlatrofm !== undefined) {
        return `${pointPlatrofm.name} (Droga nr: ${pointPlatrofm.roadNumber}, kierunek: ${pointPlatrofm.direction}, kilometr: ${pointPlatrofm.mileage})`;
    }
    return 'Brak danych';
};

export const mapToPlatform = (metricPointPlatformUId: string, metricLocalization: MetricLocalization | null): string => {
    if(metricLocalization === null){
        return 'Brak danych'; 
    }
    const localizations = metricLocalization.metricPointPlatforms;
    const pointPlatrofm: MetricPointPlatformType | undefined = localizations.find((x: MetricPointPlatformType) => x.uId === metricPointPlatformUId);
    if (pointPlatrofm !== undefined) {
        return pointPlatrofm.name;
    }
    return 'Brak danych';
};